import React from "react";
import { Theme } from "@astryxdesign/core/theme";
import { neutralTheme } from "@astryxdesign/theme-neutral";
import { useDocumentTheme } from "../../hooks/useDocumentTheme";
import styles from "./AuthLayout.module.css";

export interface AuthLayoutProps {
  /** The screen's content, centred on the backdrop. */
  children: React.ReactNode;
}

/**
 * The signed-out shell, ported from the Electron app's login screen: a
 * full-bleed image under a scrim in the theme's own page colour, with the
 * content centred on top.
 *
 * Devise pages render outside the dashboard SPA, so this carries its own
 * Astryx <Theme> and follows the same `data-theme` toggle as the dashboard —
 * every other auth component MUST be rendered inside it.
 */
const AuthLayout = ({ children }: AuthLayoutProps): React.ReactElement => {
  const mode = useDocumentTheme();

  return (
    <Theme theme={neutralTheme} mode={mode}>
      <div className={styles.backdrop}>
        <main className={styles.layout}>{children}</main>
      </div>
    </Theme>
  );
};

export default AuthLayout;
